<template>
  <div class="statistic" id="statistic-rating" v-if="isView()">
    <div class="statistic-item badge bg" data-bs-toggle="modal" :data-bs-target="'#' + modalId + postId">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-heart me-1">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
      </svg>
      <span class="count">
        <span class="like">{{ like }}</span>/<span class="dislike">{{ dislike }}</span>
      </span>
    </div>
    <!--<Teleport to="body">
      <ModalInfo :modal-id="modalId + postId" title="Рейтинг">
        <p v-if="comment.length" v-html="comment"></p>
        <p v-else>Данных пока нет.</p>
      </ModalInfo>
    </Teleport>-->
  </div>
</template>

<script>
import {defineComponent, watch, ref, toRaw} from "vue"
import StoreRegister from "@/plugins/store/services/StoreRegister"
import stores from "./stores"
import {
  getData as statisticGetData, storeName as statisticStoreName
} from "./services/statistic"
//import ModalInfo from '@/components/modals/modal_info/ModalInfo'

StoreRegister.handle(statisticStoreName, stores)

export default defineComponent({
  name: "StatisticRating",
  components: {
    //ModalInfo,
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    let like = ref(0);
    let dislike = ref(0);
    //let comment = ref('')
    const modalId = 'infoPointStatisticRating'
    const postId = props.data["post_id"]

    watch(() => statisticGetData(), (val) => {
      render(toRaw(val))
    })

    function render(payload) {
      if (payload[props.data["post_id"]] !== undefined) {
        like.value = payload[props.data["post_id"]]["like"]
        dislike.value = payload[props.data["post_id"]]["dislike"]
        //comment.value = "comment!"
      }
    }

    function isView() {
      if (like.value === 0 && dislike.value === 0) {
        return false
      }

      return true
    }

    return {
      like,
      dislike,
      //comment,
      postId,
      modalId,
      isView,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
